exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".QuizCreator__QuizCreator--2R7qz {\n    display: flex;\n    justify-content: center;\n    padding-top: 50px;\n    flex-grow: 1;\n    width: 100%;\n    background: linear-gradient(270deg, #f0613c 0%, #f0783c 100%);\n}\n\n.QuizCreator__QuizCreator--2R7qz > div {\n    width: 100%;\n    max-width: 600px;\n    padding: 0 20px;\n}\n\n.QuizCreator__QuizCreator--2R7qz h1 {\n    text-align: center;\n    color:#fff;\n}\n\n.QuizCreator__QuizCreator--2R7qz form {\n    background: #eee;\n    border-radius: 5px;\n    padding: 15px;\n    box-shadow: 2px 2px 2px rgba(0, 0, 0, .5);\n}", ""]);

// exports
exports.locals = {
	"QuizCreator": "QuizCreator__QuizCreator--2R7qz"
};